import { createSlice } from "@reduxjs/toolkit";

const defaultPlanogramState = {
  input: "",
  imageData: {},
  load: false,
  page: "default",
  prevPage: "default",
  pos: { x: window.innerWidth - 325, y: 100 },
  openMenu: true,
  activeView: "planogram"
}

export const planogramSlice = createSlice({
  name: "planogram",
  initialState: {
    ...defaultPlanogramState
  },
  reducers: {
    handleInputChange(state, action) {
      state.input = action.payload;
    },
    handleChangeView(state, action) {
      state.activeView = action.payload;
    },
    setImageData(state, action) {
      state.imageData = action.payload;
    },
    setLoading(state, action) {
      state.load = action.payload
    },
    changePage(state, action) {
      state.page = action.payload
    },
    setPrevPage(state, action) {
      // if a page is clicked twice, it won't update prev page
      if (state.page !== action.payload) {
        state.prevPage = action.payload
      }
    },
    setPos(state, action) {
      state.pos = action.payload
    },
    setopenMenu(state, action) {
      state.openMenu = action.payload
    }
  }
})